import React from 'react'
import { Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { signOut } from '../../common/auth/actions'
import { Title } from '../components'
import { UserForm } from '../forms'

const UserPage = ({ viewer, signOut }) => (
  <div>
    <Title message="Nastavení" />
    <aside className="breadcrumbs">
      <span>Nastavení</span>
      <div className="options">
        <button onClick={signOut} className="logout with-icon"><Icon name="power" /> Odhlásit se</button>
      </div>
    </aside>
    <main className="form-page thin">
      <UserForm user={viewer} redirect={false} />
    </main>
  </div>
)

UserPage.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  signOut: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  viewer: state.users.viewer,
}), { signOut })(UserPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Settings.js